import { gql } from '@apollo/client'
import { COMPANY_STAFF_FRAGMENT } from '../Fragments'
import { Simulate } from 'react-dom/test-utils'
import input = Simulate.input

export const COMPANY_STAFFS_QUERY = gql`
  query getCompanyStaffs($contactId: ID!) {
    companyStaffs(contactId: $contactId) {
      ...CompanyStaffFragment
    }
  }
  ${COMPANY_STAFF_FRAGMENT}
`

export const COMPANY_STAFF_CREATE = gql`
  mutation CompanyStaffCreate($companyStaff: CompanyStaffArgument!) {
    companyStaffCreate(companyStaff: $companyStaff) {
      companyStaff {
        ...CompanyStaffFragment
      }
    }
  }
  ${COMPANY_STAFF_FRAGMENT}
`

export const COMPANY_STAFF_UPDATE = gql`
  mutation CompanyStaffUpdate($id: ID!, $companyStaff: CompanyStaffArgument!) {
    companyStaffUpdate(id: $id, companyStaff: $companyStaff) {
      companyStaff {
        ...CompanyStaffFragment
      }
    }
  }
  ${COMPANY_STAFF_FRAGMENT}
`

export const COMPANY_STAFF_DESTROY = gql`
  mutation CompanyStaffDestroy($id: ID!) {
    companyStaffDestroy(id: $id) {
      destroyed
    }
  }
`

export const COMPANY_STAFF_DESTROY_ALL = gql`
  mutation CompanyStaffDestroyAll($contactId: ID!, $roles: [String!]) {
    companyStaffDestroyAll(contactId: $contactId, roles: $roles) {
      destroyed
    }
  }
`
